package crashreporting

data class CrashReporterConfig(
    val dsn: String,
    val appName: String = "app",
    val enabled: Boolean = true,
    val debug: Boolean = false,
    val environment: String = "prod",
    val release: String? = null,
    val dist: String? = null,
    val defaultTags: Map<String, String> = emptyMap(),
    val logger: CrashReporterLogger = CrashReporterLogger.None,
)
